import { ActorType } from "../types/general";

// INFO: Логировать ли ошибки при авторизации
export const MS_LOGIN_DEBUG = "app.settings.authentication.logging-debug";

// INFO: Значение свойства iss в токене, который был выпущен МС Аутентификации
export const MS_TOKEN_ISSUER = "owb-plt-ms-authentication";

// INFO: Минимальное время до истечения времени жизни токена для отправки запроса на обновление
export const EXPIRATION_DATE_OFFSET_IN_SECONDS = 10;

// INFO: Список авторизационных зон
export const AUTH_ZONES = {
  MAIN_PAGE: "main",
  CHOOSE_ORGANIZATION_PAGE: "choose-organization",
  MINI_LK_PAGE: "mini-lk",
};

// INFO: Список акторов
export const ACTOR_TYPES: Record<string, ActorType> = {
  USER: "USER",
  DELEGATE: "ORG_DELEGATE",
};

export const REDIRECT_QUERY_PARAM = "next";

/**
 * INFO: Названия ключей в local storage, которые позволяют выбрать необходимый
 * сценарий механизма редиректов и аутентификации (Монолит или МС Аутентификации).
 */
export const HAS_REFRESH_TOKEN = "hasRefreshToken";

/**
 * INFO: Ключ в local storage указывающий, что вход с мобильного/планшета, то переводим пользователя на страницу Мини-ЛК
 */
export const ADAPTIVE = "adaptive";
export const MINI_LK = "isMiniLk";
export const CURRENT_AUTH_ZONE = "currentAuthZone";

// INFO: Название ключа в localStorage для определения наличия SSO refresh-токена
export const HAS_SSO_REFRESH_TOKEN = "hasSsoRefreshToken";

export const MINI_LK_PAGE_PATHNAME_REGEXP = /^\/login\/mini-lk\/?$/;

export const EVENT_TYPES = {
  ON_ACCESS_TOKEN_RECEIVED: "onAccessTokenReceived",
} as const;
